import { useState, useEffect, useRef } from "react";
import { QuizEngine } from "@shikaku/shared";

export function useQuizEngine() {
  const engineRef = useRef<QuizEngine | null>(null);
  if (!engineRef.current) {
    engineRef.current = new QuizEngine();
  }
  const engine = engineRef.current;

  const [, setTick] = useState(0);

  useEffect(() => {
    engine.setOnChange(() => setTick((t) => t + 1));
    return () => engine.setOnChange(() => {});
  }, [engine]);

  return engine;
}
